export default __webpack_public_path__ + "static/media/eb-ultra-blk-4.88f431a0.png";